import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { AzureFileStorageLocation } from 'app/model/dataset/location/azure-file-storage.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureFileStorageLocation)
})
export class AzureFileStorageLocationAdapter extends FileLocationAdapter<AzureFileStorageLocation, Model.DatasetLocation> {
    public _toResource(store: AzureFileStorageLocation): Model.FileServerLocation {
        const resource: Model.AzureFileStorageLocation = {
            type: AzureFileStorageLocation.MODEL.name,
            fileName: ValueAdapter.toResource(store, AzureFileStorageLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, AzureFileStorageLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.AzureFileStorageLocation, owner: Named): AzureFileStorageLocation {
        const model = Owned.create<AzureFileStorageLocation>(AzureFileStorageLocation.MODEL, owner);
        ValueAdapter.toModel(model, AzureFileStorageLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, AzureFileStorageLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
